"use strict";
exports.__esModule = true;
exports.setupWalletEndpoints = void 0;
var utils_1 = require("../utils");
var getBasePath = (0, utils_1.getBasePathFactory)('/wallet');
function setupWalletEndpoints(api) {
    return api.injectEndpoints({
        endpoints: function (build) { return ({
            getFundsActivity: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/funds/activity");
                }
            }),
            getWalletSettings: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/settings");
                }
            }),
            getWalletBalance: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/balance");
                }
            }),
            getCards: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/cards");
                }
            }),
            withdrawFunds: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, amount = _a.amount;
                    return ({
                        url: "".concat(getBasePath(customerId), "/funds/withdraw"),
                        method: 'POST',
                        body: { amount: amount }
                    });
                }
            }),
            addFunds: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, amount = _a.amount;
                    return ({
                        url: "".concat(getBasePath(customerId), "/funds/add"),
                        method: 'POST',
                        body: { amount: amount }
                    });
                }
            }),
            setupCard: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, stripe_payment_method_id = _a.stripe_payment_method_id, stripe_card_element_token = _a.stripe_card_element_token, is_onboarding = _a.is_onboarding;
                    return ({
                        url: "".concat(getBasePath(customerId), "/cards/setup"),
                        method: 'POST',
                        body: { stripe_payment_method_id: stripe_payment_method_id, stripe_card_element_token: stripe_card_element_token, is_onboarding: is_onboarding }
                    });
                }
            }),
            addCard: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, stripe_setup_intent_id = _a.stripe_setup_intent_id, stripe_card_element_token = _a.stripe_card_element_token;
                    return ({
                        url: "".concat(getBasePath(customerId), "/cards/add"),
                        method: 'POST',
                        body: { stripe_setup_intent_id: stripe_setup_intent_id, stripe_card_element_token: stripe_card_element_token }
                    });
                }
            }),
            getWalletEligibility: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/eligibility");
                }
            }),
            getWithdrawableAmount: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/funds/withdrawable-amount");
                }
            })
        }); }
    });
}
exports.setupWalletEndpoints = setupWalletEndpoints;
